export enum ImportFreeWallQueryParams {
  SourceId = 'sourceId',
  DestinationId = 'destinationId'
}
